import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { airtableEmbedUrl } from "../../helpers/airtableEmbed";
import type { AirtableEmbedIds } from "../../helpers/airtableEmbed";

const EMBED_SRC = "https://airtable.com/embed/apprWesJGBmsmfsWx/shr6GCzjVWUoMJZSY";

// Ids for this view's interface page and gallery element — see helpers/airtableEmbed.
const EMBED_IDS: AirtableEmbedIds = {
  pageId: "pagxWAPXmZ18UUbej",
  elementId: "pelmRq7Es03cfYFxv",
  queryContainerId: "pel5a0Qa082fHT6yP",
};

export default function AllResourcesPage() {
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();

  // /app/all-resources?rec=recXXXXXXXXXXXXXX opens that resource expanded.
  const src = airtableEmbedUrl(EMBED_SRC, EMBED_IDS, searchParams.get("rec"));

  // The embed can't be steered once loaded, so a different record means a new
  // iframe — show the spinner again while it loads.
  useEffect(() => setLoading(true), [src]);

  return (
    <main className="all-resources-page page">
      <div className="w-full h-[calc(100vh-100px)] relative">
        <h1 className="flex text-5xl font-semibold text-gray-800 portrait:text-3xl lg:text-5xl md:text-5xl sm:text-3xl ps-6 py-6">
              All Resources</h1>
        {loading && (
          <div className="absolute inset-0 flex items-center justify-center bg-white z-10">
            <span className="loader"></span>
          </div>
        )}

        <iframe
          key={src}
          title="All Resources"
          className="airtable-embed"
          src={src}
          frameBorder="0"
          width="100%"
          height="100%"
          style={{ background: "transparent", border: "1px solid var(--color-border-subtle)" }}
          onLoad={() => setLoading(false)}
        />
      </div>
    </main>
  );
}
